import React from 'react';

import Layout from 'layouts/Layout';
import Catalog from './Catalog';

const CatalogLayout = () => <Layout component={Catalog} hasGrid />;

export default CatalogLayout;
